import { useEffect } from 'react'

import { InputSelectControl } from '../InputSelectControl'
import { Select } from '../Select'
import { useSyncSelectStates } from '../Select.hooks'
import { filterSyncSelectOptionsByLabel } from '../Select.utils'

function InputSelect({
  Control = InputSelectControl,
  blocked,
  controlProps,
  disabled,
  dropdownFloatingConfig,
  dropdownProps,
  error,
  filter = filterSyncSelectOptionsByLabel,
  initialSearchValue,
  listProps,
  multi,
  options,
  selectStatesRef,
  value,
  onChangeSearch,
  onClear,
  onSelectAll,
  onSelectItem,
  ...restProps
}) {
  const selectStates = useSyncSelectStates({
    blocked,
    disabled,
    dropdownFloatingConfig,
    filter,
    initialSearchValue,
    multi,
    options,
    value,
    onChangeSearch,
    onSelectAll,
    onSelectItem,
  })

  const {
    activeIndex,
    context,
    elementsRef,
    filteredOptions,
    floatingStyles,
    getFloatingItemProps,
    getFloatingProps,
    getReferenceProps,
    handleChangeSearch,
    handleClearSearch,
    handleClose,
    handleKeyDown,
    handleOpen,
    handleSelect,
    handleToggleOpen,
    handleToggleShowSelected,
    isOpen,
    refs,
    searchValue,
    showSelected,
  } = selectStates

  useEffect(() => {
    if (selectStatesRef) {
      selectStatesRef.current = selectStates
    }
  }, [selectStates])

  return (
    <Select
      {...restProps}
      Control={Control}
      activeIndex={activeIndex}
      contextProps={{
        blocked,
        disabled,
        error,
        getFloatingItemProps,
        multi,
        searchValue,
        showSelected,
        value,
        onChangeSearch: handleChangeSearch,
        onClear,
        onClearSearch: handleClearSearch,
        onClose: handleClose,
        onOpen: handleOpen,
        onSelect: handleSelect,
        onToggleOpen: handleToggleOpen,
        onToggleShowSelected: handleToggleShowSelected,
      }}
      controlProps={{
        ...controlProps,
        ...getReferenceProps({ disabled, onKeyDown: handleKeyDown }),
      }}
      dropdownProps={{
        ...dropdownProps,
        context,
        floatingStyles,
        getFloatingProps,
      }}
      isOpen={isOpen}
      listProps={{
        ...listProps,
        elementsRef,
        headerProps: {
          ...listProps?.headerProps,
          Search: listProps?.headerProps?.Search ?? null,
        },
      }}
      options={filteredOptions}
      refs={refs}
    />
  )
}

export default InputSelect
